export default __webpack_public_path__ + "static/media/pause.ad4d84cb.svg";